import { instance4 } from "App/constants";
import { today } from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const RESET_STATE_PEMBAYARAN = {
  tanggal_masuk: today(true),
  tipe_pembayaran_id: 1,
  kas_id: null,
  kas_name: "Pilih Kas",
  jumlah_bayar2: "",
  pembelian_id: "",

  no_kartu: "",
  no_transfer: "",
};

export const getPembayaranByPembelianID = async (pembelianID) => {
  try {
    const api = await instance4.get(
      `${LIST_URL_WAREHOUSE.pembayaranLGS.getById}/${pembelianID}`
    );

    if (api.data.status === 200) {
      return {
        state: true,
        data: api.data.data,
      };
    } else {
      return {
        state: false,
        message: api.data.message,
      };
    }
  } catch (error) {
    console.log(error.response);
    return {
      state: false,
      message: "error",
    };
  }
};

export const deletePembayaranPembelianByID = async (id) => {
  try {
    const api = await instance4.post(
      LIST_URL_WAREHOUSE.pembayaranLGS.delete,
      {
        id,
      }
    );

    if (api.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: api.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error.response.data.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "pembelian_id",
    disablePadding: false,
    label: "PEMBELIAN ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_supplier",
    disablePadding: false,
    label: "NAMA SUPPLIER",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "tanggal_masuk",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_bayar",
    disablePadding: false,
    label: "JUMLAH BAYAR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaKas",
    disablePadding: false,
    label: "KAS",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_pembayaran_id",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_kartu",
    disablePadding: false,
    label: "TIPE KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_kartu",
    disablePadding: false,
    label: "NO KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_transfer",
    disablePadding: false,
    label: "NO TRANSFER",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
